import * as React from "react";
import { Modal } from "@mui/material";
import uploadFileService from "../../services/uploadFile.service";
import ModalUI from "../UI/ModalUI";

const ImageViewModal = (props) => {
  const {
    imageLabel,
    imageURL,
    onChangeImageUrl,
    height,
    width,
    open,
    ...others
  } = props;

  const [imageUrlTemp, setImageUrlTemp] = React.useState(null);

  const getData = async (id) => {
    try {
      //   const data = await uploadFileService.loadImage2(id);
      const data = await uploadFileService.loadImage2(id);
      setImageUrlTemp(data);
      return data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return message;
    }
  };

  // / test image

  // / test image
  // const handleOnloadImage = async (id) => {
  //   dispatch(loadImageUrlById({ id: id }));
  // };

  // React.useEffect(() => {
  //   setImageUrlTemp(loadImageUrl);
  // }, [loadImageUrl]);

  React.useEffect(() => {
    // handleOnloadImage(others.fileId);
    getData(others.fileId);
  }, [others.fileId]);

  // test image

  return (
    <ModalUI formname={props?.title} open={open} {...others}>
      <div>
        <img
          height={"100%"}
          width={"100%"}
          src={others.fileId ? imageUrlTemp : imageURL}
          alt="image"
        ></img>
      </div>
    </ModalUI>
  );
};

export default ImageViewModal;
